import React from 'react';

const KanbanColumn = ({ title, count, children, className = '', statusColor = '#D1D1D1' }) => {
	return (
		<div className={`task-column ${className}`}>
			<div
				className="task-column-header d-flex align-items-center justify-content-start"
				style={{
					borderBottom: `2px solid ${statusColor}`
				}}
			>
				<p className="d-flex align-items-center  weight-500">
					<span
						className="round-dot mr-2"
						style={{
							backgroundColor: statusColor
						}}
					></span>{' '}
					{title}
				</p>
				<span className="circel-count gray_dark_02 ml-2">{count}</span>
			</div>
			<div className="task-column-body">{children}</div>
		</div>
	);
};

export default KanbanColumn;
